import React from "react";
import {
  Container,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Grid,
  useTheme,
  useMediaQuery,
} from "@mui/material";

// Данные о преподавателях
const teachersData = [
  { id: 1, fullName: " Рагалиева Жания Болатовна", position: "экономика" },
  { id: 2, fullName: " Ахонова Гульнара Кентибаевна", position: "экономика" },
  { id: 3, fullName: " Жаксимбетова Гульнара Ахметовна", position: "құқық" },
  { id: 4, fullName: " Шукеева Нургуль Борисовна", position: "құқық" },
  { id: 5, fullName: " Сапина Аигерим Болатовна", position: "құқық" },
  {
    id: 6,
    fullName: " Аубакирова Клара Мураткалиевна",
    position: "ақпараттық",
  },
  {
    id: 7,
    fullName: " Габдрахимов Даурен Куанышкалиевич",
    position: "ақпараттық",
  },
  {
    id: 8,
    fullName: " Смагулова Айгерим Женисхановна",
    position: "ақпараттық",
  },
  {
    id: 9,
    fullName: " Киланбекова Дилара Бисенбіқызы",
    position: "ақпараттық",
  },
  { id: 10, fullName: " Багисов Женис Жайлиевич", position: "ақпараттық" },
];

const teachersDataSplitIndex = Math.ceil(teachersData.length / 2);
const teachersDataLeft = teachersData.slice(0, teachersDataSplitIndex);
const teachersDataRight = teachersData.slice(teachersDataSplitIndex);

const generalEducationTeachers = [
  {
    id: 1,
    fullName: "Габдешова Мансия Наримановна",
    position: "қазақ тілі мен қазақ әдебиеті пәні оқытушысы",
    requirement: "-",
    currentCategory: "-",
    requestedCategory: "-",
    grantedCategory: "-",
  },
  {
    id: 2,
    fullName: "Куаншалиева Райгуль Тлеккабыловна",
    position: "қазақ тілі мен қазақ әдебиеті пәні оқытушысы",
    requirement: "-",
    currentCategory: "-",
    requestedCategory: "-",
    grantedCategory: "-",
  },
  {
    id: 3,
    fullName: "Шанкиева Бахыт Габдрашовна",
    position: "орыс тілі мен орыс әдебиеті пәні оқытушысы",
    requirement: "-",
    currentCategory: "-",
    requestedCategory: "-",
    grantedCategory: "-",
  },
  {
    id: 4,
    fullName: "Утегалиева Айгуль Еслямгалиевна",
    position: "ағылшын тілі пәні оқытушысы",
    requirement: "-",
    currentCategory: "-",
    requestedCategory: "-",
    grantedCategory: "-",
  },
  {
    id: 5,
    fullName: "Ютиш Екатерина Александровна",
    position: "ағылшын тілі пәні оқытушысы",
    requirement: "-",
    currentCategory: "-",
    requestedCategory: "-",
    grantedCategory: "-",
  },
  {
    id: 6,
    fullName: "Маратова Аида Маратовна",
    position: "тарих пәні оқытушысы",
    requirement: "-",
    currentCategory: "-",
    requestedCategory: "-",
    grantedCategory: "-",
  },
  {
    id: 7,
    fullName: "Кенжегалиев Азамат Максутович",
    position: "тарих пәні оқытушысы",
    requirement: "-",
    currentCategory: "-",
    requestedCategory: "-",
    grantedCategory: "-",
  },
  {
    id: 8,
    fullName: "Сапа Мирдан Гимранұлы",
    position: "тарих пәні оқытушысы",
    requirement: "-",
    currentCategory: "-",
    requestedCategory: "-",
    grantedCategory: "-",
  },
  {
    id: 9,
    fullName: "Джумахметова Лилия Киреевна",
    position: "математика пәні оқытушысы",
    requirement: "-",
    currentCategory: "-",
    requestedCategory: "-",
    grantedCategory: "-",
  },
  {
    id: 10,
    fullName: "Тасжанова Балжан Кенесовна",
    position: "математика пәні оқытушысы",
    requirement: "-",
    currentCategory: "-",
    requestedCategory: "-",
    grantedCategory: "-",
  },
  {
    id: 11,
    fullName: "Аяпова Роза Ермековна",
    position: "физика және информатика пәні оқытушысы",
    requirement: "-",
    currentCategory: "-",
    requestedCategory: "-",
    grantedCategory: "-",
  },
  {
    id: 12,
    fullName: "Дюсегалиева Кайрлы Окасовна",
    position: "физика және информатика пәні оқытушысы",
    requirement: "-",
    currentCategory: "-",
    requestedCategory: "-",
    grantedCategory: "-",
  },
  {
    id: 13,
    fullName: "Конырбаева Гульнара Халесовна",
    position: "химия және биология пәні оқытушысы",
    requirement: "-",
    currentCategory: "-",
    requestedCategory: "-",
    grantedCategory: "-",
  },
  {
    id: 14,
    fullName: "Жұмағалиев Нұрберген Серікұлы",
    position: "география пәні оқытушысы",
    requirement: "-",
    currentCategory: "-",
    requestedCategory: "-",
    grantedCategory: "-",
  },
  {
    id: 15,
    fullName: "Давлетов Нурлан Темиргалиевич",
    position: "дене тәрбиесі пәні оқытушысы",
    requirement: "-",
    currentCategory: "-",
    requestedCategory: "-",
    grantedCategory: "-",
  },
  {
    id: 16,
    fullName: "Хабиев Абай Максотович",
    position: "дене тәрбиесі пәні оқытушысы",
    requirement: "-",
    currentCategory: "-",
    requestedCategory: "-",
    grantedCategory: "-",
  },
  {
    id: 17,
    fullName: "Нургалиев Кенжебек Жасгасбаевич",
    position: "алғашқы әскери дайындық пәні оқытушысы",
    requirement: "-",
    currentCategory: "-",
    requestedCategory: "-",
    grantedCategory: "-",
  },
  {
    id: 18,
    fullName: "Бунькина Ольга Борисовна",
    position: "психолог - маман",
    requirement: "-",
    currentCategory: "-",
    requestedCategory: "-",
    grantedCategory: "-",
  },
];

const technicalTeachers = [
  {
    id: 1,
    fullName: "Мақсотова Айгерім Тасболатқызы",
    position: "Радиотехника, электроника и телекоммуникации",
    requirement: "-",
    currentCategory: "-",
    requestedCategory: "-",
    grantedCategory: "-",
  },
  {
    id: 2,
    fullName: "Супалдиярова Гульмира Есмагамбетова",
    position: "Радиотехника, электроника и телекоммуникации",
    requirement: "-",
    currentCategory: "-",
    requestedCategory: "-",
    grantedCategory: "-",
  },
  {
    id: 3,
    fullName: "Галламова Айгерим Алтаевна",
    position: "Нефтегазовая отрасаль",
    requirement: "-",
    currentCategory: "-",
    requestedCategory: "-",
    grantedCategory: "-",
  },
  {
    id: 4,
    fullName: "Садыкова Жанар Бейсеновна",
    position: "Радиотехника, электроника и телекоммуникации",
    requirement: "-",
    currentCategory: "-",
    requestedCategory: "-",
    grantedCategory: "-",
  },
  {
    id: 5,
    fullName: "Сариева Ботагөз Қайратқызы",
    position: "Радиотехника, электроника и телекоммуникации",
    requirement: "-",
    currentCategory: "-",
    requestedCategory: "-",
    grantedCategory: "-",
  },
  {
    id: 6,
    fullName: "Беккалиев Акболат Ербулатович",
    position: "Радиотехника, электроника и телекоммуникации",
    requirement: "-",
    currentCategory: "-",
    requestedCategory: "-",
    grantedCategory: "-",
  },
  {
    id: 7,
    fullName: "Айтмұханбетова Анара Талапқызы",
    position: "Радиотехника, электроника и телекоммуникации",
    requirement: "-",
    currentCategory: "-",
    requestedCategory: "-",
    grantedCategory: "-",
  },
  {
    id: 8,
    fullName: "Отарбаева Жанат Омиржановна",
    position: "Радиотехника, электроника и телекоммуникации",
    requirement: "-",
    currentCategory: "-",
    requestedCategory: "-",
    grantedCategory: "-",
  },
  {
    id: 9,
    fullName: "Хайрушева Гулден Айбековна",
    position: "Радиотехника, электроника и телекоммуникации",
    requirement: "-",
    currentCategory: "-",
    requestedCategory: "-",
    grantedCategory: "-",
  },
  {
    id: 10,
    fullName: "Тулемисова Самал Серикқызы",
    position: "Нефтегазовая отрасаль",
    requirement: "-",
    currentCategory: "-",
    requestedCategory: "-",
    grantedCategory: "-",
  },
  {
    id: 11,
    fullName: "Нуруллина Жанар Елеубаевна",
    position: "Строительство и эксплуатация зданий и сооружений",
    requirement: "-",
    currentCategory: "-",
    requestedCategory: "-",
    grantedCategory: "-",
  },
  {
    id: 12,
    fullName: "Абильгазиев Дамир Курмангазиевич",
    position:
      "Техническое обслуживание, ремонт и эксплуатация автомобильного транспорта",
    requirement: "-",
    currentCategory: "-",
    requestedCategory: "-",
    grantedCategory: "-",
  },
  {
    id: 13,
    fullName: "Кенжесова Венера Исатаевна",
    position: "Нефтегазовая отрасаль",
    requirement: "-",
    currentCategory: "-",
    requestedCategory: "-",
    grantedCategory: "-",
  },
];

// Splitting data for columns
const generalEducationSplitIndex = Math.ceil(
  generalEducationTeachers.length / 2,
);
const generalTeachersLeft = generalEducationTeachers.slice(
  0,
  generalEducationSplitIndex,
);
const generalTeachersRight = generalEducationTeachers.slice(
  generalEducationSplitIndex,
);

const technicalSplitIndex = Math.ceil(technicalTeachers.length / 2);
const technicalTeachersLeft = technicalTeachers.slice(0, technicalSplitIndex);
const technicalTeachersRight = technicalTeachers.slice(technicalSplitIndex);

const formatPCKName = name => {
  const parts = name.trim().split(/\s+/);
  if (parts.length >= 3) {
    const lastPart = parts.pop();
    return (
      <>
        {parts.join(" ")}
        <br />
        {lastPart}
      </>
    );
  }
  return name;
};

function CommissionPage() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Container maxWidth="md" sx={{ marginTop: 12, marginBottom: 4 }}>
      <Box textAlign="center" mb={4}>
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          Предметно-цикловая комиссия РВТК
        </Typography>
        <Typography variant="h6">01.01.2025</Typography>
      </Box>

      <Box mb={4}>
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          ОТДЕЛЕНИЕ
        </Typography>
        <Typography variant="body1">
          IT-технологий, нефти, газа, экономики и права <br />
          Телекоммуникация и транспорта
        </Typography>
      </Box>

      <Box mb={4}>
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          ПЦК
        </Typography>
        <Typography variant="body1" sx={{ mb: 3, fontWeight: "bold" }}>
          ПЦК информационных, экономических и правовых дисциплин
        </Typography>
        <Grid container spacing={4}>
          {isMobile ? (
            <Grid item xs={12}>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell align="center" sx={{ fontWeight: "bold" }}>
                        №
                      </TableCell>
                      <TableCell align="center" sx={{ fontWeight: "bold" }}>
                        Т.А.Ә
                      </TableCell>
                      <TableCell align="center" sx={{ fontWeight: "bold" }}>
                        Лауазымы
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {teachersData.map(teacher => (
                      <TableRow key={teacher.id}>
                        <TableCell align="center">{teacher.id}</TableCell>
                        <TableCell align="center">
                          {formatPCKName(teacher.fullName)}
                        </TableCell>
                        <TableCell align="center">{teacher.position}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          ) : (
            <>
              <Grid item xs={12} md={6}>
                <TableContainer component={Paper} sx={{ height: "100%" }}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell align="center" sx={{ fontWeight: "bold" }}>
                          №
                        </TableCell>
                        <TableCell align="center" sx={{ fontWeight: "bold" }}>
                          Т.А.Ә
                        </TableCell>
                        <TableCell align="center" sx={{ fontWeight: "bold" }}>
                          Лауазымы
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {teachersDataLeft.map(teacher => (
                        <TableRow key={teacher.id}>
                          <TableCell align="center">{teacher.id}</TableCell>
                          <TableCell align="center">
                            {formatPCKName(teacher.fullName)}
                          </TableCell>
                          <TableCell align="center">
                            {teacher.position}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
              <Grid item xs={12} md={6}>
                <TableContainer component={Paper} sx={{ height: "100%" }}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell align="center" sx={{ fontWeight: "bold" }}>
                          №
                        </TableCell>
                        <TableCell align="center" sx={{ fontWeight: "bold" }}>
                          Т.А.Ә
                        </TableCell>
                        <TableCell align="center" sx={{ fontWeight: "bold" }}>
                          Лауазымы
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {teachersDataRight.map(teacher => (
                        <TableRow key={teacher.id}>
                          <TableCell align="center">{teacher.id}</TableCell>
                          <TableCell align="center">
                            {formatPCKName(teacher.fullName)}
                          </TableCell>
                          <TableCell align="center">
                            {teacher.position}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </>
          )}
        </Grid>
        <Typography variant="body1" sx={{ mb: 3, mt: 4, fontWeight: "bold" }}>
          ПЦК общеобразовательных дисциплин
        </Typography>
        <Grid container spacing={4}>
          {isMobile ? (
            <Grid item xs={12}>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell align="center" sx={{ fontWeight: "bold" }}>
                        №
                      </TableCell>
                      <TableCell align="center" sx={{ fontWeight: "bold" }}>
                        Т.А.Ә
                      </TableCell>
                      <TableCell align="center" sx={{ fontWeight: "bold" }}>
                        Лауазымы
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {generalEducationTeachers.map(teacher => (
                      <TableRow key={teacher.id}>
                        <TableCell align="center">{teacher.id}</TableCell>
                        <TableCell align="center">{teacher.fullName}</TableCell>
                        <TableCell align="center">{teacher.position}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          ) : (
            <>
              <Grid item xs={12} md={6}>
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell align="center" sx={{ fontWeight: "bold" }}>
                          №
                        </TableCell>
                        <TableCell align="center" sx={{ fontWeight: "bold" }}>
                          Т.А.Ә
                        </TableCell>
                        <TableCell align="center" sx={{ fontWeight: "bold" }}>
                          Лауазымы
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {generalTeachersLeft.map(teacher => (
                        <TableRow key={teacher.id}>
                          <TableCell align="center">{teacher.id}</TableCell>
                          <TableCell align="center">
                            {teacher.fullName}
                          </TableCell>
                          <TableCell align="center">
                            {teacher.position}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
              <Grid item xs={12} md={6}>
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell align="center" sx={{ fontWeight: "bold" }}>
                          №
                        </TableCell>
                        <TableCell align="center" sx={{ fontWeight: "bold" }}>
                          Т.А.Ә
                        </TableCell>
                        <TableCell align="center" sx={{ fontWeight: "bold" }}>
                          Лауазымы
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {generalTeachersRight.map(teacher => (
                        <TableRow key={teacher.id}>
                          <TableCell align="center">{teacher.id}</TableCell>
                          <TableCell align="center">
                            {teacher.fullName}
                          </TableCell>
                          <TableCell align="center">
                            {teacher.position}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </>
          )}
        </Grid>

        <Typography variant="body1" sx={{ mb: 3, mt: 4, fontWeight: "bold" }}>
          ПЦК технических дисциплин
        </Typography>
        <Grid container spacing={4}>
          {isMobile ? (
            <Grid item xs={12}>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell align="center" sx={{ fontWeight: "bold" }}>
                        №
                      </TableCell>
                      <TableCell align="center" sx={{ fontWeight: "bold" }}>
                        Т.А.Ә
                      </TableCell>
                      <TableCell align="center" sx={{ fontWeight: "bold" }}>
                        Лауазымы
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {technicalTeachers.map(teacher => (
                      <TableRow key={teacher.id}>
                        <TableCell align="center">{teacher.id}</TableCell>
                        <TableCell align="center">{teacher.fullName}</TableCell>
                        <TableCell align="center">{teacher.position}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          ) : (
            <>
              <Grid item xs={12} md={6}>
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell align="center" sx={{ fontWeight: "bold" }}>
                          №
                        </TableCell>
                        <TableCell align="center" sx={{ fontWeight: "bold" }}>
                          Т.А.Ә
                        </TableCell>
                        <TableCell align="center" sx={{ fontWeight: "bold" }}>
                          Лауазымы
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {technicalTeachersLeft.map(teacher => (
                        <TableRow key={teacher.id}>
                          <TableCell align="center">{teacher.id}</TableCell>
                          <TableCell align="center">
                            {teacher.fullName}
                          </TableCell>
                          <TableCell align="center">
                            {teacher.position}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
              <Grid item xs={12} md={6}>
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell align="center" sx={{ fontWeight: "bold" }}>
                          №
                        </TableCell>
                        <TableCell align="center" sx={{ fontWeight: "bold" }}>
                          Т.А.Ә
                        </TableCell>
                        <TableCell align="center" sx={{ fontWeight: "bold" }}>
                          Лауазымы
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {technicalTeachersRight.map(teacher => (
                        <TableRow key={teacher.id}>
                          <TableCell align="center">{teacher.id}</TableCell>
                          <TableCell align="center">
                            {teacher.fullName}
                          </TableCell>
                          <TableCell align="center">
                            {teacher.position}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </>
          )}
        </Grid>
      </Box>
    </Container>
  );
}

export default CommissionPage;
